import LocationSearchButton from './locationSearchButton';

export default LocationSearchButton;
